import axios from 'axios';
import { loader } from './LoaderBridge';

axios.interceptors.request.use(config => {
  loader.start();
  return config;
});

axios.interceptors.response.use(
  response => {
    loader.stop();
    return response;
  },
  error => {
    loader.stop();
    return Promise.reject(error);
  }
);

export default axios;
